module.exports = ".exclamation2 {\n  bottom: 16px;\n  position: relative;\n  left: 173px;\n  color: #ce1442;\n  height: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/preventivo-dati-anagrafici/preventivo-dati-anagrafici.component.scss
// module id = ./src/app/preventivo-dati-anagrafici/preventivo-dati-anagrafici.component.scss
// module chunks = main